import React from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Sidebar, { SidebarBackdrop } from "../Sidebar";
import { selectSidebarOpen } from "../../../store/selectors/uiSelectors";
import { setSidebarOpen } from "../../../store/slices/uiSlice";
import { AppDispatch } from "../../../store";
import {
  MainLayoutContainer,
  MainContentArea,
} from "./MainLayout.styled";

type MainLayoutProps = {
  children: React.ReactNode;
};

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const isSidebarExpanded = useSelector(selectSidebarOpen);

  const handleBackdropClick = () => {
    dispatch(setSidebarOpen(false));
  };

  return (
    <MainLayoutContainer>
      <Box sx={{ display: "flex", flex: 1 }}>
        <Sidebar />
        <SidebarBackdrop
          expanded={isSidebarExpanded}
          onClick={handleBackdropClick}
        />
        <MainContentArea>{children}</MainContentArea>
      </Box>
    </MainLayoutContainer>
  );
};

export default MainLayout;
